import { render, staticRenderFns } from "./Start.Splash.vue?vue&type=template&id=476e18aa&"
import script from "./Start.Splash.vue?vue&type=script&lang=ts&"
export * from "./Start.Splash.vue?vue&type=script&lang=ts&"
import style0 from "./Start.Splash.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports